var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLfCameraIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.667 13.333c-.367 0-.68-.13-.942-.391A1.284 1.284 0 0 1 1.333 12V4c0-.367.13-.68.392-.942.261-.26.575-.391.942-.391h8c.366 0 .68.13.941.391.261.261.392.575.392.942v3l2.1-2.1c.111-.111.233-.139.367-.083.133.055.2.16.2.316v5.734c0 .155-.067.26-.2.316-.134.056-.256.028-.367-.083L12 9v3c0 .367-.13.68-.392.942a1.284 1.284 0 0 1-.941.391h-8Zm0-1.333h8V4h-8v8Z",
  fill: "#82B1B0"
})));
export default SvgLfCameraIcon;